'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { bootstrapNative } from '@/lib/native/bootstrap';

export default function NativeBootstrap() {
  const router = useRouter();

  useEffect(() => {
    bootstrapNative({ back: () => router.back() });
  }, [router]);

  return null;
}
